import React from "react";
import { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";
import TitleBar from "../../_common/TitleBar";
import CmtListTable from "./CmtListTable";
import { Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CmtModal_AddIssue from "./CmtModal_AddIssue";
import qmsTeamActions from "../../../_actions/_qmsActions/qmsTeamActions";
import cmtCategoryActions from "../../../_actions/_qmsActions/cmtCategoryActions";
import "./cmtIssueList.css";
import CmtChildIssueList from "./CmtChildIssueList";
import qmsActionIsAuthorized from "../_common/qmsAutorize";
import CmtModal_AddIssue_Short from "./CmtModal_AddIssue_Short";
import _ from "lodash";
import { useCallback } from "react";
import CmtModal_Delete from "./CmtModal_Delete";

export default function CmtList(props) {
  const { tab } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(cmtIssueActions.getAll(tab.payload.divisionId));
    dispatch(cmtCategoryActions.getAll(tab.payload.divisionId));
    dispatch(qmsTeamActions.getAll(tab.payload.divisionId));
  }, []);

  const ISSUE_SCOPE = useSelector((state) =>
    "ISSUE" in state.qms.permissionScopes ? state.qms.permissionScopes.ISSUE.name : null
  );

  const cmtCategories = useSelector(
    (state) => state.qms.cmtCategories[tab.payload.divisionId] || null
  );
  const qmsTeams = useSelector(
    (state) => state.qms.qmsTeams[tab.payload.divisionId] || null
  );
  const qmsUser = useSelector((state) => state.qms.qmsUser || null);
  const qrps = useSelector((state) => state.qms.qmsRolePermissions || null);

  const [modalState_delete, setModalState_delete] = useState({
    showModal: false,
    data: null,
  });
  const toggleModal_delete = () =>
    setModalState_delete({
      ...modalState_delete,
      showModal: !modalState_delete.showModal,
    });

  const pendingFilters = useRef([
    {
      id: "advFilters",
      isForPendingList: true,
      label: "Adv. Filters",
      icon: "filter",
    },
  ]);

  const getStatusColor = useCallback((statusValue) => {
    switch (statusValue) {
      case 0:
      case 1:
        return "badge-light";
      case 2:
        return "badge-warning";
      case 3:
        return "badge-danger";
      default:
        return "badge-light";
    }
  }, []);

  const getStatusIcon = useCallback((statusValue) => {
    switch (statusValue) {
      case 0:
      case 1:
        return "check";
      case 2:
      case 3:
        return "exclamation-triangle";
      default:
        return "";
    }
  }, []);

  const getCmtCategory = useCallback(
    (rowData) => {
      const cmtCategoryId = (rowData.cmtCategoryIds || [0])[0] || 0;
      if (cmtCategoryId) {
        const cmtCategory = (cmtCategories || []).find(
          (cc) => cc.cmtCategoryId === cmtCategoryId
        );
        return cmtCategory || null;
      }
      return null;
    },
    [cmtCategories]
  );

  const getOwnerSnippets = useCallback(
    (rowData) => {
      let stageOwners = _.orderBy(
        (qmsTeams || []).filter((qt) =>
          (rowData.currentStageOwnerSnippets || [])
            .filter((sos) => sos.ownerId)
            .map((sos) => sos.ownerId)
            .includes(qt.qmsTeamId)
        ),
        "name",
        "asc"
      );
      if (rowData.primaryOwnerId) {
        const primaryOwner = (qmsTeams || []).find(
          (qt) => qt.qmsTeamId === rowData.primaryOwnerId
        );
        if (primaryOwner)
          stageOwners = [{ ...primaryOwner, isPrimaryOwner: true }, ...stageOwners];
      }
      return stageOwners;
    },
    [qmsTeams]
  );

  // Expand: 3%, Check: 3%, View Button: 10%
  const pendingColumns = [
    {
      id: "issueNo",
      numeric: false,
      disablePadding: false,
      label: "ID",
      width: "10%",
      minWidth: "60px",
      render: (rowData) => (
        <div className="d-flex flex-row flex-wrap issue-list__inline-list">
          <span className="badge badge-light issue-list__inline-list-item">
            {rowData.issueNo}
          </span>
        </div>
      ),
    },
    {
      id: "subject",
      numeric: false,
      disablePadding: false,
      label: "Subject",
      width: "40%",
      minWidth: "200px",
    },
    {
      id: "initiatedOn",
      numeric: false,
      disablePadding: false,
      label: "Initiated On",
      render: (rowData) => new Date(rowData.initiatedOn).toLocaleDateString(),
      width: "14%",
      minWidth: "100px",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Status",
      width: "20%",
      minWidth: "150px",
      render: (rowData) => (
        <div className="d-flex flex-row flex-wrap issue-list__inline-list">
          {rowData.isAcknowledged ? (
            <span className="badge badge-primary issue-list__inline-list-item">
              Acknowledged
            </span>
          ) : (
            <span className="badge badge-secondary issue-list__inline-list-item">
              Submitted
            </span>
          )}
        </div>
      ),
    },
  ];

  const openFilters = [
    {
      id: "cmtCategory",
      isForPendingList: false,
      label: null,
      icon: null,
      data: {
        selectOptions: (cmtCategories || []).map((cc) => ({
          value: cc.cmtCategoryId,
          label: cc.label,
        })),
      },
    },
    {
      id: "stageOwner",
      isForPendingList: false,
      label: null,
      icon: null,
      data: {
        selectOptions: (qmsTeams || []).map((qt) => ({
          value: qt.qmsTeamId,
          label: `${qt.name}, ${qt.description}`,
        })),
      },
    },
    // {
    //   id: "advFilters",
    //   isForPendingList: false,
    //   label: "Adv. Filters",
    //   icon: "filter",
    // },
    // {
    //   id: "reports",
    //   isForPendingList: false,
    //   label: "Reports",
    //   icon: "chart-line",
    // },
  ];

  // Expand: 3%, Check: 3%, View Button: 10%
  const openColumns = [
    {
      id: "issueNo",
      numeric: false,
      disablePadding: false,
      label: "ID (+child issues)",
      width: "10%",
      minWidth: "80px",
      render: (rowData) => (
        <div className="d-flex flex-row flex-wrap issue-list__inline-list">
          <span className="badge badge-light issue-list__inline-list-item">
            {rowData.issueNo}
          </span>
          <span className="text-small my-auto">
            {rowData.childIssueCount > 0 && ` (+${rowData.childIssueCount})`}
          </span>
        </div>
      ),
    },
    {
      id: "subject",
      numeric: false,
      disablePadding: false,
      label: "Subject",
      width: "30%",
      minWidth: "200px",
    },
    {
      id: "category",
      numeric: false,
      disablePadding: false,
      label: "Category",
      width: "10%",
      searchData: (rowData) => {
        const cmtCategory = getCmtCategory(rowData);
        return cmtCategory ? cmtCategory.label : "";
      },
      render: (rowData) => {
        const cmtCategory = getCmtCategory(rowData);
        return (
          <div className="d-flex flex-row flex-wrap issue-list__inline-list">
            <span
              className={`badge badge-${
                cmtCategory ? "info" : "light"
              } issue-list__inline-list-item`}
            >
              {cmtCategory ? cmtCategory.label || "(N/A)" : "(N/A)"}
            </span>
          </div>
        );
      },
    },
    {
      id: "currentStageSnippets",
      numeric: false,
      disablePadding: false,
      label: "Current Stage(s)",
      width: "22%",
      minWidth: "100px",
      searchData: (rowData) =>
        (rowData.currentStageSnippets || []).map((stn) => stn.title),
      render: (rowData) => {
        return (
          <div className="d-flex flex-row flex-wrap issue-list__inline-list">
            {(rowData.currentStageSnippets || []).map((stn, index) => {
              const color = stn.isFromChild ? "secondary" : "dark";
              return (
                <span
                  key={`currentStageTitleKey_${index}`}
                  className={`badge badge-${color} issue-list__inline-list-item`}
                >
                  {stn.title}
                </span>
              );
            })}
          </div>
        );
      },
    },
    {
      id: "currentStageOwnerSnippets",
      numeric: false,
      disablePadding: false,
      label: "Current Owner(s)",
      width: "12%",
      minWidth: "100px",
      searchData: (rowData) => getOwnerSnippets(rowData).map((o) => o.name),
      render: (rowData) => {
        const owners = getOwnerSnippets(rowData);
        return (
          <div className="d-flex flex-row flex-wrap issue-list__inline-list">
            {(owners || []).map((o, i) => {
              if (o.isPrimaryOwner) {
                return (
                  <span className="badge badge-primary issue-list__inline-list-item">
                    {`${o.name}`}
                  </span>
                );
              }
              const ownerSnippet = (rowData.currentStageOwnerSnippets || []).find(
                (sos) => sos.ownerId === o.qmsTeamId
              );
              return (
                <span
                  key={`currentStageOwnerKey_${i}`}
                  className={`badge ${getStatusColor(
                    ownerSnippet.status
                  )} issue-list__inline-list-item`}
                >
                  {/* <FontAwesomeIcon
                    icon={getStatusIcon(ownerSnippet.status)}
                    className="fa-fw mr-1"
                  /> */}
                  {`${o.name} (${ownerSnippet.stageCount})`}
                </span>
              );
            })}
          </div>
        );
      },
    },
  ];

  // Expand: 3%, Check: 3%, View Button: 10%
  const closedColumns = [
    {
      id: "issueNo",
      numeric: false,
      disablePadding: false,
      label: "ID (+child issues)",
      width: "10%",
      minWidth: "80px",
      render: (rowData) => (
        <div className="d-flex flex-row flex-wrap issue-list__inline-list">
          <span className="badge badge-light issue-list__inline-list-item">
            {rowData.issueNo}
          </span>
          {rowData.childIssueCount > 0 && ` (+${rowData.childIssueCount})`}
        </div>
      ),
    },
    {
      id: "subject",
      numeric: false,
      disablePadding: false,
      label: "Subject",
      width: "54%",
      minWidth: "200px",
    },
    {
      id: "category",
      numeric: false,
      disablePadding: false,
      label: "Category",
      width: "20%",
      render: (rowData) => {
        const cmtCategoryId = (rowData.cmtCategoryIds || [0])[0] || 0;
        if (cmtCategoryId) {
          const cmtCategory = (cmtCategories || []).find(
            (cc) => cc.cmtCategoryId === cmtCategoryId
          );
          return (
            <div className="d-flex flex-row flex-wrap issue-list__inline-list">
              <span className="badge badge-dark issue-list__inline-list-item">
                {cmtCategory ? cmtCategory.label || "(N/A)" : "(N/A)"}
              </span>
            </div>
          );
        }
      },
    },
  ];

  const issueList = useSelector((state) =>
    tab.tabId in state.qms.openIssueLists
      ? "issueList" in state.qms.openIssueLists[tab.tabId]
        ? state.qms.openIssueLists[tab.tabId].issueList
        : null
      : null
  );

  const [modalState_add, setModalState_add] = useState({
    showModal: false,
    data: null,
  });
  const toggleModal_add = () =>
    setModalState_add({ ...modalState_add, showModal: !modalState_add.showModal });

  const [modalState_addShortForm, setModalState_addShortForm] = useState({
    showModal: false,
    data: null,
  });
  const toggleModal_addShortForm = () =>
    setModalState_addShortForm({
      ...modalState_addShortForm,
      showModal: !modalState_addShortForm.showModal,
    });

  const allowShortFormEntry = useMemo(
    () => qmsActionIsAuthorized(ISSUE_SCOPE, "create", 2),
    [ISSUE_SCOPE, qmsUser, qrps]
  );
  const showPendingIssues = useMemo(
    () => qmsActionIsAuthorized(ISSUE_SCOPE, "edit", 3),
    [ISSUE_SCOPE, qmsUser, qrps]
  );

  const pendingIssueList = useMemo(
    () => (issueList || []).filter((i) => !i.isOpen && !i.isClosed && !i.isDeleted),
    [issueList]
  );

  const openIssueList = useMemo(() => {
    console.log("il=", issueList);
    return (issueList || []).filter((i) => i.isOpen && !i.isDeleted);
  }, [issueList]);

  const closedIssueList = useMemo(
    () => (issueList || []).filter((i) => i.isClosed && !i.parentIssueId),
    [issueList]
  );

  return (
    <React.Fragment>
      <TitleBar
        titleText="Change Management Tracker - List of Issues"
        menu={null}
        handleTitleBarAction={() => {}}
      />
      <div className="d-flex flex-row w-100 mx-2">
        <div className="qms-filter-component qms-filter-component__btn mr-2">
          <button
            name="refresh"
            id="refresh"
            onClick={() => dispatch(cmtIssueActions.getAll(tab.payload.divisionId))}
            className="btn btn-secondary"
          >
            <FontAwesomeIcon icon="sync-alt" className="fa-fw mr-2" />
            Refresh
          </button>
        </div>
        <div className="qms-filter-component qms-filter-component__btn mr-2">
          <button
            name="add"
            id="add"
            onClick={() =>
              setModalState_add({ showModal: !modalState_add.showModal, data: null })
            }
            className="btn btn-info"
          >
            <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
            New Change Request...
          </button>
        </div>
        {allowShortFormEntry && (
          <div className="qms-filter-component qms-filter-component__btn">
            <button
              name="addShortForm"
              id="addShortForm"
              onClick={() => setModalState_addShortForm({ showModal: true, data: null })}
              className="btn btn-secondary"
            >
              <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
              New Change Request... (Short Form)
            </button>
          </div>
        )}
      </div>
      {showPendingIssues && (
        <CmtPendingList
          tabId={tab.tabId}
          divisionId={tab.payload.divisionId}
          pendingIssueList={pendingIssueList}
          columns={pendingColumns}
          filters={pendingFilters.current}
        />
      )}
      <div className="card m-2">
        <div className="card-body">
          <h5>Issues Currently Open</h5>
          <div className="d-flex flex-row flex-wrap w-100">
            <CmtListTable
              divisionId={tab.payload.divisionId}
              data={openIssueList}
              columns={openColumns}
              isExpandable={true}
              expandedDetailComponent={
                <div className="card my-3">
                  <div className="card-body p-3">
                    <h5>Child Issues</h5>
                    <CmtChildIssueList
                      tabId={tab.tabId}
                      divisionId={tab.payload.divisionId}
                      isExpandable={false}
                    />
                  </div>
                </div>
              }
              showSelectCheckbox={true}
              filters={openFilters}
              onDelete={(selected) =>
                setModalState_delete({
                  showModal: true,
                  data: {
                    tabId: tab.tabId,
                    divisionId: tab.payload.divisionId,
                    issueIdsToDelete: selected,
                  },
                })
              }
            />
          </div>
        </div>
      </div>
      <div className="card m-2">
        <div className="card-body">
          <h5>Closed Issues</h5>
          <div className="d-flex flex-row flex-wrap w-100">
            <CmtListTable
              divisionId={tab.payload.divisionId}
              data={closedIssueList}
              columns={closedColumns}
              isExpandable={false}
              showSelectCheckbox={true}
              filters={[]}
            />
          </div>
        </div>
      </div>
      {modalState_add.showModal && (
        <CmtModal_AddIssue
          modalState={modalState_add}
          toggleModal={toggleModal_add}
          tabId={tab.tabId}
          divisionId={tab.payload.divisionId}
        />
      )}
      {qmsUser && modalState_addShortForm.showModal && (
        <CmtModal_AddIssue_Short
          modalState={modalState_addShortForm}
          toggleModal={toggleModal_addShortForm}
          tabId={tab.tabId}
          divisionId={tab.payload.divisionId}
        />
      )}
      {modalState_delete.showModal && (
        <CmtModal_Delete
          modalState={modalState_delete}
          toggleModal={toggleModal_delete}
        />
      )}
    </React.Fragment>
  );
}

function CmtPendingList(props) {
  const { pendingIssueList, columns, tabId, divisionId, filters } = props;

  const [showPending, _setShowPending] = useState(false);
  const togglePending = () => _setShowPending(!showPending);

  return (
    <div className="card m-2 bg-lightgray">
      <div className="card-body p-2">
        <div className="card m-0">
          <div className="card-body">
            <p onClick={togglePending} className="mb-0 pointer-cursor">
              <span className="h5 mb-0 text-danger">
                <FontAwesomeIcon
                  icon={showPending ? "caret-down" : "caret-right"}
                  className="mr-2"
                />
                Pending Issues
              </span>
              <span className="h4 badge badge-danger ml-2 align-middle">
                {(pendingIssueList || []).length}
              </span>
              <span className="text-muted ml-2 align-middle my-auto">
                (Not Yet Open for Tracking)
              </span>
            </p>
            <Collapse isOpen={showPending}>
              <div className="d-flex flex-row flex-wrap w-100 mt-2">
                <CmtListTable
                  divisionId={divisionId}
                  data={pendingIssueList || []}
                  columns={columns}
                  isExpandable={false}
                  showSelectCheckbox={true}
                  filters={filters}
                />
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </div>
  );
}
